import { render } from "./dashboardTasks.vue?vue&type=template&id=451b462c&scoped=true"
import script from "./dashboardTasks.vue?vue&type=script&lang=js"
export * from "./dashboardTasks.vue?vue&type=script&lang=js"

import "./dashboardTasks.vue?vue&type=style&index=0&id=451b462c&scoped=true&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-451b462c"]])

export default __exports__